import React, { useState } from 'react';
import { useMediaQuery, screenGte } from 'modules/media/use-media-query';

import { Link } from 'react-router-dom';
import { useTheme } from 'modules/media/theme';
import { Breadcrumbs } from 'modules/app-shell/breadcrumbs';
import classNames from 'classnames';
import { LocationDescriptor } from 'history';
import { twMerge } from 'tailwind-merge';
import Button from 'modules/shared-components/button/button';

const SideBar = React.lazy(() => import('./sidebar'));

type Props = {
  pages?: any[];
  children: React.ReactNode;
  buttons?: {
    type?: string;
    buttonId?: string;
    onClickFunction?: () => void;
    title: string;
    href?: LocationDescriptor<unknown>;
    icon?: React.ReactNode;
    style?: any;
    disabled?: boolean;
  }[];
  sidebarInfo?: any;
  topRight?: React.ReactNode;
  noXsPadding?: boolean;
};

const PageTemplate = ({
  pages,
  children,
  buttons = [],
  sidebarInfo,
  topRight,
  noXsPadding = false,
}: Props) => {
  const theme = useTheme();
  const [isCondensed, setIsCondensed] = useState(false);
  const isLargeScreen = useMediaQuery(screenGte.large);

  return (
    <div className={classNames(theme, noXsPadding ? '' : 'xxs:px-2')}>
      {sidebarInfo && isLargeScreen && (
        <SideBar
          sidebarInfo={sidebarInfo}
          isCondensed={isCondensed}
          setIsCondensed={setIsCondensed}
        />
      )}
      <div
        className={
          sidebarInfo
            ? classNames(isCondensed ? 'lg:pl-12 ' : 'lg:pl-52 ')
            : 'lg:px-10 2xl:px-0'
        }
      >
        <div className={twMerge('lg:flex lg:justify-between xxs:mb-2')}>
          {pages && <Breadcrumbs pages={pages} />}
          {topRight}

          {buttons?.length > 0 && (
            <div className="xxs:my-3 lg:my-0 flex gap-1">
              {buttons?.map((button) =>
                button.type === 'button' ? (
                  <Button
                    key={button.buttonId || button.title}
                    data-testid={button.buttonId}
                    onClick={() => button.onClickFunction?.()}
                    className="w-full lg:w-auto"
                    type="button"
                    variant="neutral"
                    disabled={button.disabled}
                  >
                    <div className="flex space-x-2 items-center text-white ">
                      <div>{button.icon}</div>
                      <div>{button.title}</div>
                    </div>
                  </Button>
                ) : (
                  <Button
                    as={Link}
                    type="button"
                    key={button.buttonId || button.title}
                    to={button.href}
                    variant="neutral"
                    className="w-full lg:w-auto"
                  >
                    <div className="flex space-x-2 items-center text-white ">
                      <div>{button.icon}</div>
                      <div>{button.title}</div>
                    </div>
                  </Button>
                )
              )}
            </div>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default PageTemplate;
